import React from 'react';

import { useLanguage } from '../LanguageContext';

export default function MailingAddressStep({
  formData,
  setFormData,
  onNext,
  onBack,
}) {
  const { t } = useLanguage();
  return (
    <div className="space-y-6 text-center font-normal">
      <h2 className="text-4xl font-normal-bold tracking-tight text-wedding-heading">
        {t('rsvp_form.mailing_address_title')}
      </h2>
      <textarea
        value={formData.mailingAddress}
        onChange={(e) =>
          setFormData((s) => ({
            ...s,
            mailingAddress: e.target.value,
          }))
        }
        className="input-wedding mt-4 h-56"
        placeholder={t('rsvp_form.mailing_address_placeholder')}
      />
    </div>
  );
}
